type IntercomId = string | undefined;
export const INTERCOM_APP_ID_TEST: IntercomId = 'wr17k7hy';
export const INTERCOM_APP_ID_PROD: IntercomId = 'tzakor5q';
